import { ReactNode } from 'react';

import { UsePaymentMessagingPropsT } from '@consumer-frontend/nc-utils';

import { useMessageEarlyAmountDue } from './useMessageEarlyAmountDue';
import { useMessageEarlyAmountDueAutoPayAndNonAutopay } from './useMessageEarlyAmountDueAutoPayAndNonAutopay';
import { useMessageEarlyFullPayoff } from './useMessageEarlyFullPayoff';
import { useMessageInAdditionToAutopay } from './useMessageInAdditionToAutopay';
import { useMessagePartialPayment } from './useMessagePartialPayment';
import { useMessagePartialPaymentNonAutopay } from './useMessagePartialPaymentNonAutopay';

export type UsePaymentMessagingT = (props: UsePaymentMessagingPropsT) => ReactNode[] | undefined;

// Hook
export const usePaymentMessaging: UsePaymentMessagingT = (props) => {
  // Get messages from individual message hooks
  const inAdditionToMessage = useMessageInAdditionToAutopay(props);
  const earlyAmountDueMessage = useMessageEarlyAmountDue(props);
  const earlyFullPayoffMessage = useMessageEarlyFullPayoff(props);
  const earlyAmountDueNonAutoPayMessage = useMessageEarlyAmountDueAutoPayAndNonAutopay(props);
  const partialPaymentMessage = useMessagePartialPayment(props);
  const partialPaymentMessageNonAutopayMessage = useMessagePartialPaymentNonAutopay(props);

  return [
    earlyAmountDueNonAutoPayMessage,
    inAdditionToMessage,
    earlyAmountDueMessage,
    earlyFullPayoffMessage,
    partialPaymentMessage,
    partialPaymentMessageNonAutopayMessage,
  ].filter(Boolean);
};
